import React, { useState, useCallback, useEffect } from 'react';
import Cropper from 'react-easy-crop';
import getCroppedImg from './cropImage';
import Swal from 'sweetalert2';
import axios from 'axios';
import { AWS_REGION, S3_CLIENTS_IMAGES } from '../../utils';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';
import './style.css';

function EditImgModal({
  open,
  onOpenChange,
  img,
  onUpdate,
  clientId,
  storeOriginal
}) {
  const [image, setImage] = useState('');
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [aspect, setAspect] = useState(1 / 1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    storeOriginal(img);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [img]);
  const uploadImgToS3 = async (img) => {
    setLoading(true);

    const config = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'image/*'
      }
    };
    console.log(`S3_CLIENTS_IMAGES: ${S3_CLIENTS_IMAGES}`);
    // let imageUrl = img.split(`/${S3_CLIENTS_IMAGES}/`)[1];
    let imageUrl = img;
    console.log(`imageUrl: ${imageUrl}`);

    if (imageUrl === undefined) {
      console.log('undefined');
      imageUrl = `${img}?time=${new Date().getTime()}`;
    } else {
      console.log(
        `https://${S3_CLIENTS_IMAGES}.s3.${AWS_REGION}.amazonaws.com/${imageUrl}`
      );
      imageUrl = `https://${S3_CLIENTS_IMAGES}.s3.${AWS_REGION}.amazonaws.com/${imageUrl}?time=${new Date().getTime()}`;
    }

    let img_to_crop = img.includes('?')
      ? (imageUrl = `${img}&time=${new Date().getTime()}`)
      : (imageUrl = `${img}?time=${new Date().getTime()}`);

    await axios
      .get(`${img_to_crop}`, config)
      .then((response) => {
        if (response.data) {
          const objectURL = URL.createObjectURL(response.data);
          setImage(objectURL);
          setLoading(false);
        }
      })
      .catch((error) => {
        Swal.fire({
          title: 'Error!',
          text: 'The url is not valid!'
        }).then((res) => {
          if (res.value) {
            setImage('');
          }
        });
        setLoading(false);
        console.error(error);
      });
  };

  useEffect(() => {
    if (img) {
      if (img.split(':')[0] === 'blob') {
        setImage(img);
      } else {
        uploadImgToS3(img);
      }
    }
    // eslint-disable-next-line
  }, [img]);

  useEffect(() => {
    if (croppedImage) {
      onUpdate(croppedImage);
    }
  }, [croppedImage, onUpdate]);

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        image,
        croppedAreaPixels,
        rotation
      );
      setCroppedImage(croppedImage);
      onOpenChange(false);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation, image, onOpenChange]);

  const zoomRange = () => {
    return (
      <React.Fragment>
        <label
          htmlFor="customRange1"
          className="font-semibold text-gray-900"
          style={{ fontSize: '14px', display: 'block', marginBottom: '8px' }}>
          Zoom {Math.floor((zoom * 100) / 3)} %
        </label>
        <input
          type="range"
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          style={{ accentColor: '#3766a8', marginBottom: '16px' }}
          value={zoom}
          min={1}
          max={3}
          step={0.1}
          onChange={(e) => setZoom(e.target.value)}
        />
      </React.Fragment>
    );
  };

  const rotationRange = () => {
    return (
      <React.Fragment>
        <label
          htmlFor="customRange1"
          className="font-semibold text-gray-900"
          style={{ fontSize: '14px', display: 'block', marginBottom: '8px' }}>
          Rotation {rotation} °
        </label>
        <input
          type="range"
          className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          style={{ accentColor: '#3766a8', marginBottom: '16px' }}
          value={rotation}
          min={0}
          max={360}
          step={1}
          onChange={(e) => setRotation(e.target.value)}></input>
      </React.Fragment>
    );
  };

  const aspectRatio = () => {
    const ratios = ['1:1', '3:4', '4:3', '9:16', '16:9', '9:21', '21:9'];
    return (
      <div className="mb-3">
        <label
          className="font-semibold text-gray-900"
          style={{ fontSize: '14px', display: 'block', marginBottom: '12px' }}>
          Aspect ratio
        </label>
        <div className="flex flex-wrap gap-2">
          {ratios.map((ratio, idx) => {
            let nums = ratio.split(':');
            let calc = nums[0] / nums[1];
            return (
              <label
                key={idx}
                className="flex items-center cursor-pointer"
                style={{ marginBottom: '8px' }}>
                <input
                  type="radio"
                  id={`customRadio${ratio}`}
                  name={'ratio'}
                  className="w-4 h-4 border-gray-300 focus:ring-2"
                  style={{ accentColor: '#3766a8', marginRight: '6px' }}
                  onChange={() => setAspect(calc)}
                />
                <span className="text-gray-700" style={{ fontSize: '13px' }}>
                  {ratio}
                </span>
              </label>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-7xl max-h-[90vh] overflow-hidden p-0">
        <DialogHeader className="px-6 pt-6 pb-4">
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-xl bg-primary/10 flex items-center justify-center">
              <i className="fas fa-image text-lg text-primary"></i>
            </div>
            <DialogTitle className="text-xl font-semibold">
              Edit Image
            </DialogTitle>
          </div>
        </DialogHeader>

        <div className="px-6 pb-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Cropper Area */}
            <div className="lg:col-span-2">
              <div
                className="crop-container relative bg-muted/50 rounded-lg overflow-hidden border"
                style={{
                  height: '500px',
                  maxHeight: '60vh'
                }}>
                {loading ? (
                  <div className="flex items-center justify-center h-full">
                    <Loader2 className="h-8 w-8 animate-spin text-primary" />
                  </div>
                ) : (
                  <Cropper
                    image={image}
                    crop={crop}
                    zoom={zoom}
                    rotation={rotation}
                    style={{
                      mediaClassName: 'crop-class',
                      containerStyle: {
                        width: '100%',
                        height: '100%'
                      }
                    }}
                    aspect={aspect}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onZoomChange={setZoom}
                  />
                )}
              </div>
            </div>

            {/* Controls Area */}
            <div className="space-y-6">
              {aspectRatio()}
              {zoomRange()}
              {rotationRange()}
            </div>
          </div>
        </div>

        <DialogFooter className="px-6 pb-6 pt-0">
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}>
            Close
          </Button>
          <Button
            type="button"
            className="bg-green-600 hover:bg-green-700"
            onClick={() => showCroppedImage()}>
            Save changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default EditImgModal;
